import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Alert from '../Alert';
import storage from '../../Store/storage';
import { RootStoreInterface } from '../../Store/index';
import { qav } from '../../Utils/qav';
interface Props {
    pageName?: string;
    unbindAlertVisiable?: boolean;
    toggleUnbindAlert?(show: boolean): void;
    openBindView?(): void;
}

@inject((store: RootStoreInterface) => ({
    unbindAlertVisiable: store.bindNotice.unbindAlertVisiable,
    toggleUnbindAlert: store.bindNotice.toggleUnbindAlert,
    openBindView: store.bindNotice.openBindView,
    pageName: store.pageName
}))
@observer
class BindAlert extends Component<Props> {
    public onOk = async () => {
        const { toggleUnbindAlert, openBindView, pageName } = this.props;
        toggleUnbindAlert(false);
        await storage.setItem('hasShowBindConfirm', 'anyValue', {
            day: 7
        });
        openBindView();
        qav({
            page: pageName,
            module: 'bindNoticeAlert',
            path: [{ title: '订单绑定提示弹窗确定按钮', position: '0' }],
            operType: 'click'
        });
    };

    public onCancel = async () => {
        const { toggleUnbindAlert } = this.props;
        toggleUnbindAlert(false);
        await storage.setItem('hasShowBindConfirm', 'anyValue', {
            day: 7
        });
    };

    public render() {
        const { unbindAlertVisiable } = this.props;
        const accessLabelInfo:Object = global.orderAccessibilityLabel(global.orderAccessibilityLabelName.BIND_ALERT)

        return (
            <Alert
                isVisible={unbindAlertVisiable}
                // isVisible={true}
                onOk={()=>{
                    this.onOk()
                    this.props.onClose && this.props.onClose()
                }}
                onCancel={()=>{
                    this.onCancel()
                    this.props.onClose && this.props.onClose()
                }}
                content="绑定订单至你的账户中，查询更方便快捷"
                title="您有未绑定订单"
                btnText="查看未绑定订单"
                accessLabelInfo={accessLabelInfo}
            />
        );
    }
}
export default BindAlert;
